import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  TemplateRef
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'suka-date-picker-input',
  template: `
    <div class="date-picker-input"
      [ngClass]="{
        'date-picker--single' : type === 'single',
        'date-picker--range' : type === 'range',
        'skeleton' : skeleton
      }">
      <div class="date-picker-input-container">
        <label *ngIf="label" [for]="id" class="label">
          <ng-container *ngIf="!isTemplate(label)">{{label}}</ng-container>
          <ng-template *ngIf="isTemplate(label)" [ngTemplateOutlet]="label"></ng-template>
        </label>
        <div class="date-picker-input__wrapper">
          <input
            *ngIf="!skeleton"
            autocomplete="off"
            type="text"
            class="date-picker__input"
            [value]="value"
            [pattern]="pattern"
            [placeholder]="placeholder"
            [id]= "id"
            [disabled]="disabled"
            (change)="onChange($event)"/>
            <suka-icon
              icon="calendar"
              class="date-picker__icon">
            </suka-icon>
        </div>
        <div *ngIf="invalid" class="form-requirement">
          <ng-container *ngIf="!isTemplate(invalidText)">{{invalidText}}</ng-container>
          <ng-template *ngIf="isTemplate(invalidText)" [ngTemplateOutlet]="invalidText"></ng-template>
        </div>
      </div>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DatePickerInput,
      multi: true
    }
  ]
})
export class DatePickerInput {
  private static datePickerCount = 0;

  /**
   * Select a calendar type for the `model`.
   * Internal purposes only.
   */
  @Input() type: 'simple' | 'single' | 'range' = 'simple';

  @Input() id = `datepicker-${DatePickerInput.datePickerCount++}`;

  @Input() hasIcon = false;

  @Input() label: string | TemplateRef<any>;

  @Input() placeholder = 'dd/mm/yyyy';

  @Input() pattern = '^\\d{1,2}/\\d{1,2}/\\d{4}$';

  @Output() valueChange: EventEmitter<string> = new EventEmitter();

  @Input() disabled = false;

  @Input() invalid = false;

  @Input() invalidText: string | TemplateRef<any>;

  @Input() skeleton = false;

  @Input() value = '';

  constructor(protected elementRef: ElementRef) { }

  onChange(event) {
    this.value = event.target.value;
    this.valueChange.emit(this.value);
    this.propagateChange(this.value);
    this.onTouched();
  }

  public writeValue(value: any) {
    this.value = value;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  onTouched: () => any = () => { };

  propagateChange = (_: any) => { };

  public isTemplate(value) {
    return value instanceof TemplateRef;
  }
}
